module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/babel-runtime/core-js/object/create.js
// module id = 838
// module chunks = 0